import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { DiscountThemeService } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

@Component({
  standalone: true,
  selector: 'cake-info-price',
  imports: [CommonModule, TranslateModule, NgCakeItEasyUtilsModule],
  templateUrl: './cake-info-price.component.html',
  styleUrls: ['./cake-info-price.component.scss']
})
export class CakeInfoPriceComponent {
  @Input() price: number;
  @Input() discount: number;
  @Input() isSinglePiecesCake: boolean;
  @Input() currency: string;
  @Input() unitName: string;

  protected discountTheme = inject(DiscountThemeService);
}
